// extracted by mini-css-extract-plugin
module.exports = {"conatainer":"SearchCatalogue_conatainer__6Wdp5","category-title":"SearchCatalogue_category-title__x7kK_"};